module.exports = __webpack_public_path__ + "static/media/empty.c2cb9520.svg";